import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import CreateEntityDrawer from '../../common/create-entity-drawer/create-entity-drawer';
import BranchesListing from './branches-listing/branches-listing';
import CreateBranchForm from './create-branch-form/create-branch-form';

function Branches() {
  return (
    <div className="content-container">
      <Box> 
            <BranchesListing />
      </Box>
    </div>
  );
}

export default Branches;
